export const ColumnProps = {
	title: {type: String},                                                                                          //列标题
	field: {type: String},                                                                                          //列绑定的字段
	searchField: {type: String},																					//列上绑定需要查询的字段，为了满足一些字段加密，使用非加密字段查询逻辑
	width: {default: 150},                                                                                          //列宽度
	fit: {type: Number, default: 0},                                                                                //当列不满表格宽度时，该列所占剩下宽度的权重
	order: {type: Number, default: 0},                                                                              //列排序
	fixed: {type: String, default: 'center', validator: val => LinkUtils.oneOf(val, ['left', 'center', 'right'])},     //固定列位置
	search: {type: Boolean, default: true},                                                                         //可查询
	sort: {type: Boolean, default: true},                                                                           //可排序
	quickFilter: {type: Boolean, default: false},                                                                   //可快速筛选，仅值列表列有效
	formFilter: {type: Boolean, default: false},                                                                    //是否可以表单筛选
	columnFilter: {type: Boolean, default: true},                                                                   //是否启用列筛选功能
	exactQuery: {type: Boolean, default: false},                                                                    //文本查询的时候，是否为精确查询，否则为模糊查询
	filterName: {type: String, default: 'input'},                                                                   //筛选组件名称:date,time,number,input
	filterOption: {type: Object},                                                                                   //筛选参数
	lov: {type: String},                                                                                            //值列表类型
	placeLeft: {type: Boolean},                                                                                     //当出现左滚动列的时候，是否自动设置为左固定列
	placeRight: {type: Boolean},                                                                                    //当出现右滚动列的时候，是否自动设置为右固定列
	align: {type: String, default: 'left'},                                                                         //非编辑状态下文本对其方式
	editable: {type: Boolean, default: true},                                                                       //是否可编辑
	hide: {type: Boolean},                                                                                          //是否隐藏
	disabledConfig: {type: Boolean},                                                                                //禁止配置该列
	disabledFormEdit: {type: Boolean},                                                                              //禁止在form表单中编辑
	disabledBatchModify: {type: Boolean},                                                                           //禁止批量修改
	fastRender: {type: Boolean, default: true},                                                                     //禁止批量修改
	tip: {type: String},																							//显示一个提示图标，tooltip显示提示信息

	dataType: {type: String},                                                                                       //数据格式化方式:tel,cny,money,percent
	formatter: {type: Function},                                                                                    //数据自定义格式化函数，支持异步格式化
	tooltip: {type: Boolean},                                                                                       //是否tooltip显示
	link: {type: Boolean},                                                                                          //是否以超链接的形式展示文本，并且点击的时候回派发事件
	clickWhenInEditable: {type: Boolean, default: true},                                                            //只有非编辑状态下才能出发点击事件，否则任何状态都会触发点击事件
	showInDialog: {type: Boolean},                                                                                  //非编辑状态下，点击打开弹框显示列内容
	externalData: {type: Object},                                                                                   //额外的数据，用于其他操作

	required: {type: Boolean},                                                                                      //是否必输
	rules: {type: Array | String},                                                                                  //校验规则数组
	validateOnInit: {type: Boolean, default: true},                                                                 //是否初始化的时候校验

	editableFunc: {type: Function},                                                                                 //是否可编辑判断函数
	requiredFunc: {type: Function},                                                                                 //是否必输判断函数
	getChangeField: {type: Function},                                                                               //供批量修改使用，有的列可能会修改对象中的多个属性，这里提供函数清除所有的属性值
	renderFunc: {},

	/*---------------------------------------不可用-------------------------------------------*/
	scopeSlotFunc: {type: Function},                                                                                //作用于渲染函数
	click: {},                                                                                                      //监听的click事件
	translate: {type: Function},                                                                                    //列筛选转义函数
	getFiltersRawBySortFilterText: {type: Function},                                                                //列筛选，通过sortFilterText获取查询参数
}

export const refreshProps = [
	'fit',
	'order',
	'fixed,',
	'placeLeft',
	'placeRight',
	'hide',
	'disabledConfig',
]

export const ColumnMixin = {
	props: ColumnProps,
	inject: ['baseTable'],
	computed: {
		columnBinding() {
			const ret = Object.keys(ColumnProps).reduce((ret, key) => {
				ret[key] = this[key]
				return ret
			}, {})
			ret.titleScopedSlot = this.$scopedSlots.title
			ret.scopeSlotFunc = this.$scopedSlots.default
			ret.click = this.$listeners.click
			return ret
		},
		columnItemBinding() {
			return {
				field: this.field,
				editable: this.editable,
				align: this.align,
				dataType: this.dataType,
				tooltip: this.tooltip,
				link: this.link,
				scopeSlotFunc: this.$scopedSlots.default,

				required: this.required,
				rules: this.rules,
				validateOnInit: this.validateOnInit,

				editableFunc: this.editableFunc,
				requiredFunc: this.requiredFunc,
				tableEditableFunc: this.baseTable.editableFunc,
				tableRequiredFunc: this.baseTable.requiredFunc,

				renderFunc: this.renderFunc,
			}
		},
	},
	methods: {
		/**
		 * 点击子行动作事件
		 * @author  韦胜健
		 * @date    2019/1/10 17:45
		 */
		lv_clickItem({event, row, editRow, rowIndex, field, editable}) {
			if (!editable && this.showInDialog && !/^(<.*>).*(<\/.*>)$/.test(event.target.innerHTML)) {
				/*当点击的内容为纯文本时，点击在弹框中文本域显示*/
				this.$dialog.show({editType: 'textarea', editReadonly: true, editValue: row[field]})
			}
			if (!!this.clickWhenInEditable && !!editable) return
			this.$emit('click', {row, editRow, rowIndex, field, editable})
		},
		col() {
			return this.$refs.column.col();
		},
	},
}

export const ColumnItemMixin = {
	props: {
		row: {},                                                                                                        //行数据对象
		editRow: {},                                                                                                    //行编辑数据对象
		rowIndex: {},                                                                                                   //行数据索引
		col: {},                                                                                                        //单元格渲染列
		colIndex: {},                                                                                                   //单元格索引
		field: {},                                                                                                      //列绑定字段
		editable: {type: Boolean, default: true},                                                                       //是否可编辑
		align: {type: String, default: 'left'},                                                                         //非编辑状态下文本对其方式
		dataType: {type: String},                                                                                       //数据格式化方式:tel,cny,money,percent
		tooltip: {type: Boolean},                                                                                       //是否tooltip显示文本
		link: {type: Boolean},                                                                                          //是否以超链接的形式展示文本，并且点击的时候回派发事件
		scopeSlotFunc: {type: Function},                                                                                //渲染文本的渲染函数
		externalData: {type: Object},                                                                                   //额外的数据，用于其他操作
		fixedRow: {},                                                                                                   //是否为固定行

		required: {type: Boolean},                                                                                      //是否必输
		rules: {type: Array | String},                                                                                  //校验规则数组
		validateOnInit: {type: Boolean, default: true},                                                                 //是否初始化的时候校验

		editableFunc: {type: Function},                                                                                 //是否可编辑判断函数
		tableEditableFunc: {type: Function},                                                                                 //是否可编辑判断函数
		requiredFunc: {type: Function},                                                                                 //是否必输判断函数
		tableRequiredFunc: {type: Function},                                                                                 //是否必输判断函数

		renderFunc: {},
	},
	data() {
		return {
			currentEditable: false,                                                                                     //当前行是否被设置为可编辑
			p_controller: null,                                                                                         //pl-table-cell-controller
			controllerEditable: null,                                                                                   //controller是否指明是否可编辑
			controllerRequired: null,                                                                                   //controller是否指明required
		}
	},
	computed: {
		lv_editableFunc() {
			return this.editableFunc || this.tableEditableFunc
		},
		lv_requiredFunc() {
			return this.requiredFunc || this.tableRequiredFunc
		},
		/**
		 * 当前是否可编辑
		 * @author  韦胜健
		 * @date    2019/1/10 15:31
		 */
		lv_editable() {
			if (this.rowIndex == null && this.colIndex == null) return
			if (this.controllerEditable != null) return this.controllerEditable
			const editable = this.currentEditable && this.editable
			if (!editable) {
				return false
			} else {
				if (!!this.lv_editableFunc) {
					const flag = this.lv_editableFunc(this.lv_data)
					return flag == null ? true : flag
				} else {
					return true
				}
			}
		},
		/**
		 * 当前是否必输
		 * @author  韦胜健
		 * @date    2019/1/18 15:59
		 */
		lv_required() {
			if (this.rowIndex == null && this.colIndex == null) return
			if (this.controllerRequired != null) return this.controllerRequired
			if (!!this.lv_requiredFunc) {
				const flag = this.lv_requiredFunc(this.lv_data)
				return flag == null ? this.required : flag
			} else {
				return this.required
			}
		},
		/**
		 * 用于判断常用参数
		 * @author  韦胜健
		 * @date    2019/1/18 16:35
		 */
		lv_data() {
			return {
				row: this.row,
				editRow: this.editRow,
				rowIndex: this.rowIndex,
				field: this.field
			}
		},
		/**
		 * 当前应该展示数据的row
		 * @author  韦胜健
		 * @date    2019/1/11 10:52
		 */
		showRow() {
			if (!!this.p_controller && !!this.p_controller.editSourceRow) return this.row
			return this.currentEditable ? this.editRow : this.row
		},
		scopeSlotData() {
			return {
				row: this.row,
				rowIndex: this.rowIndex,
				editRow: this.editRow,
				field: this.field,
				editable: this.lv_editable,
				col: this.col,
				colIndex: this.colIndex,
				showRow: this.showRow,
				fixedRow: this.fixedRow,
			}
		},
	},
	mounted() {
		this.p_controller = this.$lv.$dom.findComponentUpward(this, 'pl-table-cell-controller')
		if (!!this.p_controller) this.rowIndex != null && this.colIndex != null && this.p_controller.p_add(this)
	},
	beforeDestroy() {
		!!this.p_controller && this.p_controller.p_remove(this)
	},
	methods: {
		/**
		 * 开启编辑状态
		 * @author  韦胜健
		 * @date    2019/1/8 10:21
		 */
		enableEdit() {
			this.currentEditable = true
		},
		/**
		 * 关闭编辑状态
		 * @author  韦胜健
		 * @date    2019/1/8 10:21
		 */
		disableEdit() {
			this.currentEditable = false
		},
		handleClick(e) {
			this.$emit('click', {
				event: e,
				row: this.row,
				editRow: this.editRow,
				rowIndex: this.rowIndex,
				field: this.field,
				editable: this.lv_editable,
			})
		},
	}
}


export class TableColumn {
	constructor(context) {
		const originalProps = Object.keys(ColumnProps).reduce((ret, key) => {
			// context.$set(ret, key, context[key])
			ret[key] = context[key]
			return ret
		}, {})
		if (LinkVue.$utils.typeOf(originalProps.width) === 'string' && originalProps.width.indexOf('button') !== -1) {
			const [number] = originalProps.width
			originalProps.width = Number(number) * 28 + 40
		} else {
			originalProps.width = context.$lv.$utils.removePx(originalProps.width)
		}
		this.originalProps = originalProps
		this.settingProps = context.$lv.$utils.deepCopy(originalProps)
		this.colScopedSlot = context.$scopedSlots.default
		this.titleScopedSlot = context.titleScopedSlot || context.$scopedSlots.title
		Object.assign(this, originalProps)
		this.id = (originalProps.field || '') + (originalProps.title || '')

		this.colRef = () => context
	}
}

export const ColumnGroupProps = {
	title: {},                                  //多级表头标题
	order: {type: Number, default: 0},          //多级表头排序序号
	fixed: {type: String, default: 'center'},   //多级表头固定位置
	placeLeft: {type: Boolean},                 //当出现左滚动列的时候，是否自动设置为左固定列
	placeRight: {type: Boolean},                //当出现右滚动列的时候，是否自动设置为右固定列
	align: {type: String, default: 'center'},

	isCtrlGroup: {type: Boolean},               //是否为列控制器服务
}

export class TableColumnGroup {
	constructor(context) {
		const originalProps = Object.keys(ColumnGroupProps).reduce((ret, key) => {
			// context.$set(ret, key, context[key])
			ret[key] = context[key]
			return ret
		}, {})
		this.originalProps = originalProps
		Object.assign(this, originalProps)

		this.colRef = () => context
	}
}
